export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 145,
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: 'opt'
    }
  },
  {
    title: that.$l('table_label_orderDeductionNo') || '扣款单编号',
    field: 'orderDeductionNo',
    minWidth: 150,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.order_form_label_salesPersonCode') || '业务人员',
    field: 'salesPersonName',
    width: 150,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_requestDate') || '申请日期',
    field: 'requestDate',
    width: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_orderDeductionStatus') || '状态',
    field: 'v_orderDeductionStatus',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: 'status'
    }
  },
  {
    title: that.$l('table_label_currencyAmount') || '费用合计',
    field: 'v_currencyAmount',
    minWidth: 150,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: 'showAmount'
    }
  },
  {
    title: that.$l('table_label_deductionCustName') || '扣款客户',
    field: 'deductionCustName',
    minWidth: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_deductionMethod') || '扣款方式',
    field: 'v_deductionMethod',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },

  {
    title: that.$l('INDEX.table_label_created_by') || '创建人',
    field: 'createByName',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_created_date') || '创建时间',
    field: 'createTime',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'modifyByName',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_modification_date') || '修改时间',
    field: 'modifyTime',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true
  }
]
